var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-sticking': _vm.isSticking }},[(!_vm.stickTo)?_c('div',{ref:"defaultGlue",staticStyle:{"position":"fixed","top":"0"}}):_vm._e(),_c('div',{ref:"wrapper",staticClass:"sticky-wrapper",style:({
                'z-index': _vm.isSticking ? _vm.zIndex : 'auto',
                width: _vm.isSticking ? _vm.stickyWidth + 'px' : 'auto',
                top: _vm.stickyTop + 'px',
            })},[_vm._t("default",null,{"isSticking":_vm.isSticking})],2),(_vm.isSticking)?_c('div',{ref:"placeholder",staticClass:"placeholder w-full",style:({
			height: _vm.placeholderHeight + 'px',
		})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }